"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setAuth = exports.adminSlice = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var initialState = {
    isAuth: false,
};
exports.adminSlice = (0, toolkit_1.createSlice)({
    name: 'admin',
    initialState: initialState,
    reducers: {
        setAuth: function (state, action) {
            state.isAuth = action.payload;
        },
    },
});
exports.setAuth = exports.adminSlice.actions.setAuth;
exports.default = exports.adminSlice.reducer;
